const getters = {
  appliedFilters (state, getters, rootState, rootGetters) {
    return rootGetters.filtersQueryFor('newsroomFacts', false)
  }
}
export default {
  namespaced: true,
  getters
}
